import React, { Component } from "react";
import { Modal, Form, Input, Row, Spin } from "antd";
import { observer, inject } from "mobx-react";
import co from "co";

const { TextArea } = Input;

const FormItem = Form.Item;

@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class BatchLinksForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	getValues = () => {
		return {
			links: this.props.form.getFieldValue("links")
		};
	};

	render() {
		return (
			<Form layout="vertical">
				<FormItem label="Links">
					<p style={{ fontSize: 12 }}>
						Each url per line in the following format:
					</p>
					<p style={{ fontSize: 11 }}>
						<b>http://site.com|x|anchor|x|linksOnPage</b> or <br />
						<b>http://site.com|x|anchor</b> or <br />
						<b>http://site.com</b>
					</p>
					{this.props.form.getFieldDecorator("links", {
						rules: [
							{
								required: true,
								message: "Please enter links"
							}
						]
					})(<TextArea style={{ height: 200 }} />)}
				</FormItem>
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class BatchLinksDialog extends Component {
	mapPropsToFields = () => {
		const {
			rootStore: { linksStore }
		} = this.props;

		const ui = linksStore.ui;

		if (ui.currentLinkBatch == null) {
			return {};
		} else {
			return {
				links: Form.createFormField({
					value: ui.currentLinkBatch
				})
			};
		}
	};

	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	addLinks = () => {
		const {
			rootStore: { linksStore }
		} = this.props;

		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) {
					return;
				}
				linksStore.remoteBatchLinks(this.internalForm.getValues().links);
			}.bind(this)
		);
	};

	hideDialog = () => {
		const {
			rootStore: { linksStore }
		} = this.props;

		linksStore.hideBatchLinksDialog();
	};

	render() {
		const {
			rootStore: { linksStore }
		} = this.props;

		const ui = linksStore.ui;

		let title = "Add Links";

		const spinning = ui.addingLinks == true;
		return (
			<Modal
				visible={ui.batchLinksDialogVisible}
				title={title}
				okText="Save"
				onCancel={this.hideDialog}
				onOk={this.addLinks}
			>
				<Spin spinning={spinning}>
					<BatchLinksForm
						fields={this.mapPropsToFields()}
						wrappedComponentRef={internalForm => {
							this.internalForm = internalForm;
						}}
					/>
				</Spin>
			</Modal>
		);
	}
}

export default BatchLinksDialog;
